import {
  BadgeErrorSubtle,
  ButtonSmallError,
  ButtonSmallPrimary,
} from "@studio3t/generic-components";
import styled from "styled-components";

// One chip of the bar under the composer (Figma Bridge_Sidebar
// 15949-168524): the design system's small Primary button — outlined
// while it is off, filled while it is on, greyed while there is nothing
// to attach — and its Error sibling for a failing test run. The library
// button drops `title`, so the tooltip rides on a wrapper; that wrapper
// also keeps hover for a disabled chip, which the library renders with
// pointer-events off.
export function AttachmentChip({
  label,
  selected,
  available = true,
  error = false,
  title,
  testId,
  onClick,
}: {
  label: string;
  selected: boolean;
  available?: boolean;
  error?: boolean;
  title: string;
  testId?: string;
  onClick?: () => void;
}) {
  const Button = error ? ButtonSmallError : ButtonSmallPrimary;
  return (
    <ChipHolder title={title}>
      <Button
        text={label}
        active={selected}
        disabled={!available}
        onClick={onClick}
        testId={testId}
      />
    </ChipHolder>
  );
}

/** The one entry of the bar that is not a choice: the last run's error
 *  always goes with the message. A badge, not a button — nothing to press,
 *  nothing to focus — in the same red as a failing test chip. */
export function AttachmentIndicator({
  label,
  title,
}: {
  label: string;
  title: string;
}) {
  return (
    <ChipHolder title={title}>
      <BadgeErrorSubtle>{label}</BadgeErrorSubtle>
    </ChipHolder>
  );
}

const ChipHolder = styled.span`
  display: inline-flex;
`;
